var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g2, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _g3, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaybill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 153,
    viewBox: "0 0 206 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_605_135523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.448 98.3937H78.6821C76.5601 98.3937 74.8423 96.6759 74.8423 94.554V26.2968C74.8423 24.1748 76.5601 22.457 78.6821 22.457H128.448C130.57 22.457 132.287 24.1748 132.287 26.2968V94.554C132.287 96.6759 130.57 98.3937 128.448 98.3937Z",
    fill: "url(#paint0_linear_605_135523)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.031 79.9785H97.0967C95.6567 79.9785 94.4946 78.8164 94.4946 77.3764C94.4946 75.9365 95.6567 74.7744 97.0967 74.7744H110.031C111.471 74.7744 112.633 75.9365 112.633 77.3764C112.633 78.8164 111.471 79.9785 110.031 79.9785Z",
    fill: "#D5DDEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.967 85.6111H91.1342C90.3763 85.6111 89.77 85.0048 89.77 84.247C89.77 83.4891 90.3763 82.8828 91.1342 82.8828H115.967C116.725 82.8828 117.331 83.4891 117.331 84.247C117.331 84.9796 116.725 85.6111 115.967 85.6111Z",
    fill: "#D5DDEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.54 49.5384C120.54 54.6413 118.292 59.2137 114.73 62.3209C111.749 64.9229 107.834 66.4892 103.564 66.4892C99.2951 66.4892 95.3795 64.9229 92.3986 62.2957C88.8367 59.1885 86.5884 54.616 86.5884 49.5131C86.5884 40.141 94.1922 32.5371 103.564 32.5371C112.937 32.5371 120.54 40.1662 120.54 49.5384Z",
    fill: "#7647EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.205 38.9199C117.869 38.9199 118.407 38.3815 118.407 37.7173C118.407 37.0531 117.869 36.5146 117.205 36.5146C116.541 36.5146 116.003 37.0531 116.003 37.7173C116.003 38.3815 116.541 38.9199 117.205 38.9199Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2881 45.4242C85.7246 45.4242 86.0785 45.07 86.0785 44.633C86.0785 44.196 85.7246 43.8418 85.2881 43.8418C84.8515 43.8418 84.4976 44.196 84.4976 44.633C84.4976 45.07 84.8515 45.4242 85.2881 45.4242Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9218 59.6478C89.3584 59.6478 89.7123 59.2936 89.7123 58.8566C89.7123 58.4197 89.3584 58.0654 88.9218 58.0654C88.4853 58.0654 88.1313 58.4197 88.1313 58.8566C88.1313 59.2936 88.4853 59.6478 88.9218 59.6478Z",
    fill: "#EAEEF9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.147 59.6478L104.24 56.1719V41.9209L93.147 45.37V59.6478Z",
    fill: "#B7BFCD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M115.333 59.6478L104.24 56.1719V41.9209L115.333 45.37V59.6478Z",
    fill: "#6D7C9A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.147 59.6478L104.24 56.1719V41.9209L93.147 45.37V59.6478Z",
    fill: "url(#paint1_linear_605_135523)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M115.333 59.6478L104.24 56.1719V41.9209L115.333 45.37V59.6478Z",
    fill: "url(#paint2_linear_605_135523)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M104.24 63.1507L93.147 59.6749V45.4238L104.24 48.8997V63.1507Z",
    fill: "#EDF1F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.24 63.1507L115.333 59.6749V45.4238L104.24 48.8997V63.1507Z",
    fill: "#DAE1ED"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M101.726 60.6374L93.147 59.6749V45.4238L104.24 48.8997L101.726 60.6374Z",
    fill: "url(#paint3_linear_605_135523)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M106.754 58.1241L115.333 59.6749V45.4238L104.24 48.8997L106.754 58.1241Z",
    fill: "url(#paint4_linear_605_135523)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.24 41.9212L99.0247 38.0176L87.7466 41.8143L93.1474 45.3704L104.24 41.9212Z",
    fill: "#DAE1ED"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.24 41.9212L109.456 38.0176L120.734 41.8143L115.333 45.3704L104.24 41.9212Z",
    fill: "#DAE1ED"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1474 45.4238L104.24 48.8997L98.707 52.429L87.7466 48.7927L93.1474 45.4238Z",
    fill: "#EFF4FD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M115.333 45.4238L104.24 48.8997L109.773 52.429L120.734 48.7927L115.333 45.4238Z",
    fill: "#EDF1F9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M107.335 28.2395C108.889 32.457 109.353 33.3941 109.505 37.5498C109.446 38.4984 109.41 39.53 108.963 40.3606C108.365 41.6312 106.904 42.5112 105.524 42.5254C104.102 42.5508 102.708 41.6802 102.081 40.3378C101.64 39.523 101.654 38.4086 102.259 37.6689C102.917 36.9595 104.075 36.7826 104.908 37.2259C105.825 37.6468 106.372 38.5221 106.574 39.4453C106.777 40.3684 106.688 41.3696 106.441 42.28C105.924 44.494 105.495 44.6011 104.227 48.3497",
    stroke: "#ABB5CC",
    strokeWidth: 0.628329,
    strokeMiterlimit: 10,
    strokeDasharray: "1.26 1.26"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109.226 26.0072C109.223 26.6273 108.646 27.0071 107.914 26.8091C107.143 26.6777 106.598 26.5423 106.563 25.9888C106.581 25.4212 107.2 25.199 107.925 24.9486C108.794 24.6032 109.177 25.4012 109.226 26.0072Z",
    fill: "#DAE2EB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M104.247 27.9041C104.638 28.3061 105.461 28.4233 105.862 27.8093C106.302 27.1285 106.679 26.6336 106.274 26.1791C105.884 25.7771 105.504 26.0478 104.634 26.3931C103.938 26.7486 103.79 27.4637 104.247 27.9041Z",
    fill: "#DAE2EB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M106.049 25.3384C106.405 25.1869 106.83 25.2981 107.02 25.5849C107.101 25.6758 107.196 25.8193 107.224 25.9243C107.527 26.6313 107.432 27.3323 107.023 27.4979C106.577 27.7302 105.961 27.3322 105.725 26.6635C105.669 26.4534 105.641 26.3484 105.599 26.1908C105.553 25.809 105.694 25.4899 106.049 25.3384C106.102 25.3243 106.049 25.3384 106.049 25.3384Z",
    fill: "#989FB0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7124 36.7203H89.0244V36.0322H88.4346V36.7203H87.7466V37.3297H88.4346V38.0177H89.0244V37.3297H89.7124V36.7203Z",
    fill: "url(#paint5_linear_605_135523)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2236 53.983H90.5356V53.2949H89.9458V53.983H89.2578V54.5924H89.9458V55.2804H90.5356V54.5924H91.2236V53.983Z",
    fill: "url(#paint6_linear_605_135523)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M121.301 54.021L120.459 53.596L120.884 52.7542L120.163 52.3899L119.738 53.2317L118.896 52.8067L118.519 53.5523L119.361 53.9773L118.936 54.8191L119.658 55.1834L120.083 54.3416L120.925 54.7666L121.301 54.021Z",
    fill: "url(#paint7_linear_605_135523)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_605_135523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.8462 86.6479H28.8393C26.7173 86.6479 24.9995 84.9301 24.9995 82.8081V38.0439C24.9995 35.9219 26.7173 34.2041 28.8393 34.2041H60.8462C62.9682 34.2041 64.686 35.9219 64.686 38.0439V82.8333C64.686 84.9553 62.9682 86.6479 60.8462 86.6479Z",
    fill: "url(#paint8_linear_605_135523)"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3018 73.9409H40.3586C39.3734 73.9409 38.5649 73.1325 38.5649 72.1472C38.5649 71.1619 39.3734 70.3535 40.3586 70.3535H49.3018C50.2871 70.3535 51.0955 71.1619 51.0955 72.1472C51.0955 73.1325 50.2871 73.9409 49.3018 73.9409Z",
    fill: "#D5DDEA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4194 77.8304H36.2663C35.7357 77.8304 35.3315 77.4009 35.3315 76.8956C35.3315 76.3651 35.761 75.9609 36.2663 75.9609H53.4194C53.9499 75.9609 54.3541 76.3904 54.3541 76.8956C54.3541 77.4009 53.9247 77.8304 53.4194 77.8304Z",
    fill: "#D5DDEA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5524 52.8985C56.5524 56.4352 54.9861 59.593 52.5357 61.7403C50.4641 63.534 47.7863 64.6203 44.8306 64.6203C41.8749 64.6203 39.1719 63.534 37.1256 61.7403C34.6752 59.593 33.1089 56.4352 33.1089 52.8985C33.1089 46.4313 38.3635 41.1768 44.8306 41.1768C51.2978 41.1768 56.5524 46.4313 56.5524 52.8985Z",
    fill: "#F7AD3C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5585 46.4818C52.9962 46.4818 53.3509 46.1267 53.3509 45.6886C53.3509 45.2506 52.9962 44.8955 52.5585 44.8955C52.1209 44.8955 51.7661 45.2506 51.7661 45.6886C51.7661 46.1267 52.1209 46.4818 52.5585 46.4818Z",
    fill: "#EAEEF9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5091 50.7711C31.797 50.7711 32.0304 50.5375 32.0304 50.2493C32.0304 49.9612 31.797 49.7275 31.5091 49.7275C31.2212 49.7275 30.9878 49.9612 30.9878 50.2493C30.9878 50.5375 31.2212 50.7711 31.5091 50.7711Z",
    fill: "#EAEEF9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9056 60.152C34.1935 60.152 34.4269 59.9184 34.4269 59.6302C34.4269 59.342 34.1935 59.1084 33.9056 59.1084C33.6177 59.1084 33.3843 59.342 33.3843 59.6302C33.3843 59.9184 33.6177 60.152 33.9056 60.152Z",
    fill: "#EAEEF9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6924 60.1517L44.0081 57.8594V48.4609L36.6924 50.7356V60.1517Z",
    fill: "#B7BFCD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M51.3235 60.1517L44.0078 57.8594V48.4609L51.3235 50.7356V60.1517Z",
    fill: "#6D7C9A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6924 60.1517L44.0081 57.8594V48.4609L36.6924 50.7356V60.1517Z",
    fill: "url(#paint9_linear_605_135523)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3237 60.1517L44.0081 57.8594V48.4609L51.3237 50.7356V60.1517Z",
    fill: "url(#paint10_linear_605_135523)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0081 62.4613L36.6924 60.169V50.7705L44.0081 53.0628V62.4613Z",
    fill: "#EDF1F9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0078 62.4613L51.3235 60.169V50.7705L44.0078 53.0628V62.4613Z",
    fill: "#DAE1ED"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M42.3505 60.8038L36.6924 60.169V50.7705L44.0081 53.0628L42.3505 60.8038Z",
    fill: "url(#paint11_linear_605_135523)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M45.6653 59.1463L51.3235 60.169V50.7705L44.0078 53.0628L45.6653 59.1463Z",
    fill: "url(#paint12_linear_605_135523)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0078 48.4612L40.5683 45.8867L33.1304 48.3906L36.6922 50.7358L44.0078 48.4612Z",
    fill: "#DAE1ED"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0078 48.4612L47.4474 45.8867L54.8853 48.3906L51.3235 50.7358L44.0078 48.4612Z",
    fill: "#DAE1ED"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6922 50.7705L44.0078 53.0628L40.3587 55.3904L33.1304 52.9923L36.6922 50.7705Z",
    fill: "#EFF4FD"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3235 50.7705L44.0078 53.0628L47.6569 55.3904L54.8853 52.9923L51.3235 50.7705Z",
    fill: "#EDF1F9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0492 39.438C47.0741 42.2195 47.3796 42.8375 47.4798 45.5782C47.4413 46.2038 47.4174 46.884 47.1224 47.4318C46.7285 48.2698 45.7651 48.8501 44.8548 48.8595C43.9171 48.8763 42.9978 48.3021 42.584 47.4168C42.2929 46.8795 42.3021 46.1445 42.7015 45.6567C43.1356 45.1888 43.8993 45.0722 44.4487 45.3645C45.0531 45.6421 45.4138 46.2194 45.5474 46.8282C45.681 47.437 45.6223 48.0973 45.4592 48.6977C45.1181 50.1578 44.8356 50.2285 43.9991 52.7006",
    stroke: "#ABB5CC",
    strokeWidth: 0.41438,
    strokeMiterlimit: 10,
    strokeDasharray: "0.83 0.83"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2962 37.9653C47.2939 38.3743 46.9133 38.6247 46.4306 38.4941C45.9224 38.4075 45.5627 38.3182 45.5396 37.9532C45.5512 37.5788 45.9597 37.4323 46.4377 37.2671C47.0109 37.0394 47.2638 37.5656 47.2962 37.9653Z",
    fill: "#DAE2EB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0125 39.2161C44.2701 39.4812 44.8131 39.5585 45.0777 39.1536C45.3678 38.7046 45.6162 38.3783 45.3493 38.0785C45.0918 37.8134 44.8412 37.9919 44.2679 38.2196C43.8084 38.4541 43.7109 38.9257 44.0125 39.2161Z",
    fill: "#DAE2EB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2009 37.5243C45.4353 37.4244 45.716 37.4977 45.8413 37.6869C45.8947 37.7468 45.9573 37.8414 45.9759 37.9107C46.1754 38.377 46.1127 38.8392 45.8435 38.9485C45.5487 39.1016 45.1427 38.8392 44.9873 38.3982C44.9501 38.2596 44.9316 38.1904 44.9038 38.0865C44.8736 37.8347 44.9665 37.6242 45.2009 37.5243C45.2357 37.515 45.2009 37.5243 45.2009 37.5243Z",
    fill: "#989FB0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4268 45.0309H33.9731V44.5771H33.5841V45.0309H33.1304V45.4328H33.5841V45.8866H33.9731V45.4328H34.4268V45.0309Z",
    fill: "url(#paint13_linear_605_135523)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4234 56.4157H34.9696V55.9619H34.5807V56.4157H34.127V56.8176H34.5807V57.2713H34.9696V56.8176H35.4234V56.4157Z",
    fill: "url(#paint14_linear_605_135523)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2595 56.441L54.7044 56.1607L54.9847 55.6055L54.5088 55.3653L54.2285 55.9204L53.6733 55.6401L53.425 56.1319L53.9802 56.4122L53.6999 56.9673L54.1758 57.2076L54.4561 56.6524L55.0113 56.9327L55.2595 56.441Z",
    fill: "url(#paint15_linear_605_135523)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_605_135523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.531 86.6479H145.524C143.402 86.6479 141.684 84.9301 141.684 82.8081V38.0439C141.684 35.9219 143.402 34.2041 145.524 34.2041H177.531C179.653 34.2041 181.371 35.9219 181.371 38.0439V82.8333C181.371 84.9553 179.653 86.6479 177.531 86.6479Z",
    fill: "url(#paint16_linear_605_135523)"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M165.985 73.9409H157.042C156.057 73.9409 155.249 73.1325 155.249 72.1472C155.249 71.1619 156.057 70.3535 157.042 70.3535H165.985C166.971 70.3535 167.779 71.1619 167.779 72.1472C167.804 73.1325 166.996 73.9409 165.985 73.9409Z",
    fill: "#D5DDEA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M170.103 77.8304H152.95C152.419 77.8304 152.015 77.4009 152.015 76.8956C152.015 76.3651 152.445 75.9609 152.95 75.9609H170.103C170.634 75.9609 171.038 76.3904 171.038 76.8956C171.038 77.4009 170.634 77.8304 170.103 77.8304Z",
    fill: "#D5DDEA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M173.262 52.8985C173.262 56.4352 171.696 59.593 169.246 61.7403C167.174 63.534 164.496 64.6203 161.541 64.6203C158.585 64.6203 155.882 63.534 153.836 61.7403C151.385 59.593 149.819 56.4352 149.819 52.8985C149.819 46.4313 155.073 41.1768 161.541 41.1768C168.008 41.1768 173.262 46.4313 173.262 52.8985Z",
    fill: "#19AE57"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M170.724 46.4818C171.161 46.4818 171.516 46.1267 171.516 45.6886C171.516 45.2506 171.161 44.8955 170.724 44.8955C170.286 44.8955 169.931 45.2506 169.931 45.6886C169.931 46.1267 170.286 46.4818 170.724 46.4818Z",
    fill: "#EAEEF9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M149.674 50.7711C149.962 50.7711 150.195 50.5375 150.195 50.2493C150.195 49.9612 149.962 49.7275 149.674 49.7275C149.386 49.7275 149.153 49.9612 149.153 50.2493C149.153 50.5375 149.386 50.7711 149.674 50.7711Z",
    fill: "#EAEEF9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M152.071 60.152C152.359 60.152 152.592 59.9184 152.592 59.6302C152.592 59.342 152.359 59.1084 152.071 59.1084C151.783 59.1084 151.549 59.342 151.549 59.6302C151.549 59.9184 151.783 60.152 152.071 60.152Z",
    fill: "#EAEEF9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M154.857 60.1517L162.173 57.8594V48.4609L154.857 50.7356V60.1517Z",
    fill: "#B7BFCD"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M169.489 60.1517L162.173 57.8594V48.4609L169.489 50.7356V60.1517Z",
    fill: "#6D7C9A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M154.857 60.1517L162.173 57.8594V48.4609L154.857 50.7356V60.1517Z",
    fill: "url(#paint17_linear_605_135523)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M169.489 60.1517L162.173 57.8594V48.4609L169.489 50.7356V60.1517Z",
    fill: "url(#paint18_linear_605_135523)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M162.173 62.4613L154.857 60.169V50.7705L162.173 53.0628V62.4613Z",
    fill: "#EDF1F9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M162.173 62.4613L169.489 60.169V50.7705L162.173 53.0628V62.4613Z",
    fill: "#DAE1ED"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M160.516 60.8038L154.857 60.169V50.7705L162.173 53.0628L160.516 60.8038Z",
    fill: "url(#paint19_linear_605_135523)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.83 59.1463L169.489 60.169V50.7705L162.173 53.0628L163.83 59.1463Z",
    fill: "url(#paint20_linear_605_135523)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M162.173 48.4612L158.733 45.8867L151.295 48.3906L154.857 50.7358L162.173 48.4612Z",
    fill: "#DAE1ED"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M162.173 48.4612L165.612 45.8867L173.05 48.3906L169.489 50.7358L162.173 48.4612Z",
    fill: "#DAE1ED"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M154.857 50.7705L162.173 53.0628L158.524 55.3904L151.295 52.9923L154.857 50.7705Z",
    fill: "#EFF4FD"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M169.489 50.7705L162.173 53.0628L165.822 55.3904L173.05 52.9923L169.489 50.7705Z",
    fill: "#EDF1F9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M164.214 39.438C165.239 42.2195 165.545 42.8375 165.645 45.5782C165.606 46.2038 165.582 46.884 165.287 47.4318C164.894 48.2698 163.93 48.8501 163.02 48.8595C162.082 48.8763 161.163 48.3021 160.749 47.4168C160.458 46.8795 160.467 46.1445 160.866 45.6567C161.301 45.1888 162.064 45.0722 162.614 45.3645C163.218 45.6421 163.579 46.2194 163.712 46.8282C163.846 47.437 163.787 48.0973 163.624 48.6977C163.283 50.1578 163.001 50.2285 162.164 52.7006",
    stroke: "#ABB5CC",
    strokeWidth: 0.41438,
    strokeMiterlimit: 10,
    strokeDasharray: "0.83 0.83"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M165.461 37.9653C165.459 38.3743 165.078 38.6247 164.596 38.4941C164.087 38.4075 163.728 38.3182 163.705 37.9532C163.716 37.5788 164.125 37.4323 164.603 37.2671C165.176 37.0394 165.429 37.5656 165.461 37.9653Z",
    fill: "#DAE2EB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M162.178 39.2161C162.435 39.4812 162.978 39.5585 163.243 39.1536C163.533 38.7046 163.781 38.3783 163.514 38.0785C163.257 37.8134 163.006 37.9919 162.433 38.2196C161.973 38.4541 161.876 38.9257 162.178 39.2161Z",
    fill: "#DAE2EB"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M163.366 37.5243C163.6 37.4244 163.881 37.4977 164.006 37.6869C164.06 37.7468 164.122 37.8414 164.141 37.9107C164.34 38.377 164.278 38.8392 164.008 38.9485C163.714 39.1016 163.308 38.8392 163.152 38.3982C163.115 38.2596 163.097 38.1904 163.069 38.0865C163.039 37.8347 163.132 37.6242 163.366 37.5243C163.401 37.515 163.366 37.5243 163.366 37.5243Z",
    fill: "#989FB0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M152.592 45.0309H152.138V44.5771H151.749V45.0309H151.295V45.4328H151.749V45.8866H152.138V45.4328H152.592V45.0309Z",
    fill: "url(#paint21_linear_605_135523)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M153.588 56.4157H153.135V55.9619H152.746V56.4157H152.292V56.8176H152.746V57.2713H153.135V56.8176H153.588V56.4157Z",
    fill: "url(#paint22_linear_605_135523)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M173.425 56.441L172.869 56.1607L173.15 55.6055L172.674 55.3653L172.394 55.9204L171.838 55.6401L171.59 56.1319L172.145 56.4122L171.865 56.9673L172.341 57.2076L172.621 56.6524L173.176 56.9327L173.425 56.441Z",
    fill: "url(#paint23_linear_605_135523)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M171.544 134.822L139.587 102.89L146.913 95.5645L178.844 127.521L171.544 134.822Z",
    fill: "#858B9B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M187.459 150.862L162.955 126.358C160.909 124.312 160.909 120.977 162.955 118.931C165.001 116.885 168.336 116.885 170.382 118.931L194.886 143.435C196.932 145.481 196.932 148.816 194.886 150.862C192.84 152.908 189.505 152.908 187.459 150.862Z",
    fill: "#858B9B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M185.716 152.429L154.19 120.902C153.457 120.169 153.457 118.982 154.19 118.224L162.248 110.166C162.981 109.433 164.168 109.433 164.926 110.166L196.453 141.693C197.185 142.425 197.185 143.612 196.453 144.37L188.394 152.429C187.636 153.161 186.449 153.161 185.716 152.429Z",
    fill: "url(#paint24_linear_605_135523)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M103.412 0C69.9657 0 42.8599 27.1058 42.8599 60.5523C42.8599 93.9736 69.9657 121.105 103.387 121.105C136.833 121.105 163.939 93.9988 163.939 60.5523C163.939 27.1058 136.833 0 103.412 0ZM103.412 109.888C76.559 109.888 54.8087 87.7845 54.8087 60.5271C54.8087 33.2697 76.559 11.1909 103.412 11.1909C130.265 11.1909 152.016 33.2949 152.016 60.5523C152.016 87.8097 130.24 109.888 103.412 109.888Z",
    fill: "url(#paint25_linear_605_135523)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_605_135523",
    x: 50.3179,
    y: 10.1948,
    width: 106.494,
    height: 124.985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.2622
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.2622
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_605_135523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_605_135523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_605_135523",
    x: 0.475086,
    y: 21.9419,
    width: 88.7354,
    height: 101.492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.2622
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.2622
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_605_135523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_605_135523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_605_135523",
    x: 117.16,
    y: 21.9419,
    width: 88.7354,
    height: 101.492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.2622
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.2622
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_605_135523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_605_135523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_605_135523",
    x1: 103.546,
    y1: 20.7005,
    x2: 103.546,
    y2: 99.2124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_605_135523",
    x1: 100.738,
    y1: 42.953,
    x2: 99.225,
    y2: 49.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_605_135523",
    x1: 100.738,
    y1: 42.953,
    x2: 99.225,
    y2: 49.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_605_135523",
    x1: 95.6339,
    y1: 55.1772,
    x2: 98.2988,
    y2: 47.6504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#6C80AA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6A86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_605_135523",
    x1: 110.227,
    y1: 57.2332,
    x2: 110.436,
    y2: 47.6818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#314F91",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_605_135523",
    x1: 88.7296,
    y1: 36.1012,
    x2: 88.7296,
    y2: 37.2156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_605_135523",
    x1: 90.2409,
    y1: 53.3639,
    x2: 90.2409,
    y2: 54.4783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_605_135523",
    x1: 120.481,
    y1: 52.6565,
    x2: 119.793,
    y2: 54.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_605_135523",
    x1: 44.8298,
    y1: 32.991,
    x2: 44.8298,
    y2: 87.2133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_605_135523",
    x1: 41.6987,
    y1: 49.1416,
    x2: 40.7008,
    y2: 53.2957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_605_135523",
    x1: 41.6987,
    y1: 49.1416,
    x2: 40.7008,
    y2: 53.2957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_605_135523",
    x1: 38.3325,
    y1: 57.2028,
    x2: 40.09,
    y2: 52.2389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#6C80AA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6A86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_605_135523",
    x1: 47.956,
    y1: 58.5587,
    x2: 48.0942,
    y2: 52.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#314F91",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_605_135523",
    x1: 33.7787,
    y1: 44.6226,
    x2: 33.7787,
    y2: 45.3576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_605_135523",
    x1: 34.7753,
    y1: 56.0074,
    x2: 34.7753,
    y2: 56.7424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_605_135523",
    x1: 54.7187,
    y1: 55.5411,
    x2: 54.2647,
    y2: 56.4403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_605_135523",
    x1: 161.514,
    y1: 32.991,
    x2: 161.514,
    y2: 87.2133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_605_135523",
    x1: 159.864,
    y1: 49.1416,
    x2: 158.866,
    y2: 53.2957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_605_135523",
    x1: 159.864,
    y1: 49.1416,
    x2: 158.866,
    y2: 53.2957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_605_135523",
    x1: 156.498,
    y1: 57.2028,
    x2: 158.255,
    y2: 52.2389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#6C80AA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6A86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_605_135523",
    x1: 166.121,
    y1: 58.5587,
    x2: 166.259,
    y2: 52.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#314F91",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_605_135523",
    x1: 151.944,
    y1: 44.6226,
    x2: 151.944,
    y2: 45.3576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_605_135523",
    x1: 152.94,
    y1: 56.0074,
    x2: 152.94,
    y2: 56.7424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_605_135523",
    x1: 172.884,
    y1: 55.5411,
    x2: 172.43,
    y2: 56.4403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_605_135523",
    x1: 153.62,
    y1: 131.302,
    x2: 197.01,
    y2: 131.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_605_135523",
    x1: 42.8044,
    y1: 60.5655,
    x2: 163.961,
    y2: 60.5655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaybill);
export default __webpack_public_path__ + "static/media/waybill.9e3694e2ddb93d6ae94c7f1414b19613.svg";
export { ForwardRef as ReactComponent };